import { useState, useCallback } from 'react';
import { adminAPI, servicesAPI } from '@/services/api';
import { MSAService } from '@/types';
import { HealthStatus } from '@/types/health';

export const useCompanyServices = () => {
  const [subscribedServices, setSubscribedServices] = useState<MSAService[]>([]);
  const [loading, setLoading] = useState(true);
  const [healthStatuses, setHealthStatuses] = useState<Record<number, HealthStatus>>({});
  const [subscribedServiceIds, setSubscribedServiceIds] = useState<Set<number>>(new Set());

  const fetchSubscribedServices = useCallback(async () => {
    try {
      setLoading(true);
      const userServices = await servicesAPI.getUserServices();
      setSubscribedServices(userServices || []);
      
      const subscribedIds = new Set<number>((userServices || []).map((s: MSAService) => s.id));
      setSubscribedServiceIds(subscribedIds);
      
      if (userServices && userServices.length > 0) {
        const serviceSlugs = userServices.map((s: MSAService) => s.service_slug);
        try {
          const healthResponse = await adminAPI.batchHealthCheck(serviceSlugs);
          const statusMap: Record<number, HealthStatus> = {};
          // service_slug를 service_id로 매핑
          Object.keys(healthResponse.results).forEach((slug) => {
            const service = userServices.find((s: MSAService) => s.service_slug === slug);
            if (service) {
              statusMap[service.id] = healthResponse.results[slug].status;
            }
          });
          setHealthStatuses(statusMap);
        } catch (healthError) {
          // Health check failed - silently continue
        }
      }
    } catch (error) {
      console.error('Failed to fetch services:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    subscribedServices,
    loading,
    healthStatuses,
    subscribedServiceIds,
    setSubscribedServiceIds,
    fetchSubscribedServices,
    setHealthStatuses,
  };
};

